import { createSlice } from '@reduxjs/toolkit'
import { InTransitSettingsType } from '../../components/Applications/Intransit/interfaces'
import { IN_TRANSIT_TABS } from '../../constants/constants'
import { IAttribute, IRelation } from '../../components/DTStudio/interfaces'
import { IShipment } from '../../components/Applications/GuestApps/interfaces'

export const default_Intransit_Tab = IN_TRANSIT_TABS.MAP_VIEW
export interface InTransitState {
    //Shipment State
    inTransitSettings: InTransitSettingsType
    shipmentAttributes: IAttribute[]
    shipmentRelations: IRelation[]

    //Publich Shipment Search properties
    publicSearchShipments: IShipment[]
    tripNumber: string
}

const initialState: InTransitState = {
    //Shipment State
    inTransitSettings: {} as InTransitSettingsType,
    shipmentAttributes: [],
    shipmentRelations: [],

    //Publich Shipment Search properties
    publicSearchShipments: [],
    tripNumber: '',
}

const inTransitSlice = createSlice({
    name: 'inTransit',
    initialState,
    reducers: {
        //Shipment State
        updateSettings(state, action) {
            state.inTransitSettings = action.payload
        },

        setShipmentAttributes(state, action) {
            state.shipmentAttributes = action.payload
        },
        setShipmentRelations(state, action) {
            state.shipmentRelations = action.payload
        },

        //Publich Shipment Search properties
        setPublicSearchShipments(state, action) {
            state.publicSearchShipments = action.payload
        },
        setTripNumberInStore(state, action) {
            state.tripNumber = action.payload
        },

        //Reset State on Organization Change
        resetInTransitState(state) {
            //Shipment State
            state.inTransitSettings = {} as InTransitSettingsType
            state.shipmentAttributes = []
            state.shipmentRelations = []
        },
    },
})

export const {
    resetInTransitState,

    //Shipment State Actions
    updateSettings,
    setShipmentAttributes,
    setShipmentRelations,

    //Publich Shipment Search properties
    setPublicSearchShipments,
    setTripNumberInStore,
} = inTransitSlice.actions
export default inTransitSlice.reducer
